import React from 'react';
import { Link, Icon } from '@landing/ui';
import SocialMediaIcon from './SocialMediaIcon';

import * as styles from './Footer.module.scss';

export default function Footer({ anchorLinks, address, phone, email, copyright }) {
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <footer className={styles.footer} id="footer">
      <div className={styles.layout}>
        <div className={styles.top}>
          <div className={styles.logoContainer}>
            <Link href="https://andersenlab.com" className={styles.logoWrap}>
              <div className={styles.logo} />
            </Link>
          </div>
          <div className={styles.navigation}>
            {anchorLinks?.map(({ alias, title }) => (
              <Link key={title} className={styles.link} href={alias}>
                {title}
              </Link>
            ))}
          </div>
          <div className={styles.info}>
            <p className={styles.address}>{address}</p>
            <div className={styles.contacts}>
              <a href={`tel:${phone.number}`} className={styles.contact}>
                <Icon name="phone" className={styles.icon} />
                <span className={styles.contactText}>{phone.label}</span>
              </a>
              <a href={`mailto:${email}`} className={styles.contact}>
                <Icon name="email" className={styles.icon} />
                <span className={styles.contactText}>{email}</span>
              </a>
            </div>
          </div>
          <button className={styles.scrollArrow} onClick={scrollTop}></button>
        </div>
        <div className={styles.bottom}>
          <div>
            <SocialMediaIcon />
          </div>
          <div className={styles.copyrightWrapper}>
            <span className={styles.copyright}>{copyright}</span>
            <Link href="https://andersenlab.com/privacy-policy" className={styles.privacyPolicy}>
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
